import React from 'react'

const Srt = () => {
   return (
      <>
		<div className="row mb-title">
			<div className="col s12 m12 l12 x12">
				<h5><b>SUPERINTENDENCIA DE RIESGOS DEL TRABAJO</b></h5>
			</div>
		</div>
		<div className="row">
			<div className="col s6 m6 l6 x6">
				<h6>Ley 24557</h6>
			</div>
			<div className="col s6 m6 l6 x6 pull-x7">
				<a href="http://servicios.infoleg.gob.ar/infolegInternet/anexos/25000-29999/27971/norma.htm" target="_blank" className="btn waves-effect waves-light bg-latitud pulse" type="submit" name="action">Ver
					<i className="material-icons right">send</i>
				</a>
			</div>
		</div>
		<div className="divider light-blue darken-4 mb-divider"></div>
		<div className="row">
			<div className="col s6 m6 l6 x6">
				<h6>Ley 26773</h6>
			</div>
			<div className="col s6 m6 l6 x6 pull-x7">
				<a href="http://servicios.infoleg.gob.ar/infolegInternet/anexos/200000-204999/203798/norma.htm" target="_blank" className="btn waves-effect waves-light bg-latitud pulse" type="submit" name="action">Ver
					<i className="material-icons right">send</i>
				</a>
			</div>
		</div>
		<div className="divider light-blue darken-4 mb-divider"></div>
		<div className="row">
			<div className="col s6 m6 l6 x6">
				<h6>Ley 27348</h6>
			</div>
			<div className="col s6 m6 l6 x6 pull-x7">
				<a href="http://servicios.infoleg.gob.ar/infolegInternet/anexos/270000-274999/272119/norma.htm" target="_blank" className="btn waves-effect waves-light bg-latitud pulse" type="submit" name="action">Ver
					<i className="material-icons right">send</i>
				</a>
			</div>
		</div>
		<div className="divider light-blue darken-4 mb-divider"></div>
		<div className="row">
			<div className="col s6 m6 l6 x6">
				<h6>Resolución 298/17</h6>
			</div>
			<div className="col s6 m6 l6 x6 pull-x7">
				<a href="http://servicios.infoleg.gob.ar/infolegInternet/anexos/270000-274999/272121/norma.htm" target="_blank" className="btn waves-effect waves-light bg-latitud pulse" type="submit" name="action">Ver
					<i className="material-icons right">send</i>
				</a>
			</div>
		</div>
		<div className="divider light-blue darken-4 mb-divider"></div>
		<div className="row">
			<div className="col s6 m6 l6 x6">
				<h6>Decreto 49/14</h6>
			</div>
			<div className="col s6 m6 l6 x6 pull-x7">
				<a href="http://servicios.infoleg.gob.ar/infolegInternet/anexos/225000-229999/225309/norma.htm" target="_blank" className="btn waves-effect waves-light bg-latitud pulse" type="submit" name="action">Ver
					<i className="material-icons right">send</i>
				</a>
			</div>
		</div>
		<div className="divider light-blue darken-4 mb-divider"></div>
		<div className="row">
			<div className="col s6 m6 l6 x6">
				<h6>Resolución 2553/13</h6>
			</div>
			<div className="col s6 m6 l6 x6 pull-x7">
				<a href="http://servicios.infoleg.gob.ar/infolegInternet/anexos/220000-224999/224288/norma.htm" target="_blank" className="btn waves-effect waves-light bg-latitud pulse" type="submit" name="action">Ver
					<i className="material-icons right">send</i>
				</a>
			</div>
		</div>
		<div className="divider light-blue darken-4 mb-divider"></div>
		<div className="row">
			<div className="col s6 m6 l6 x6">
				<h6>Resolución 268/16</h6>
			</div>
			<div className="col s6 m6 l6 x6 pull-x7">
				<a href="http://servicios.infoleg.gob.ar/infolegInternet/anexos/260000-264999/262231/norma.htm" target="_blank" className="btn waves-effect waves-light bg-latitud pulse" type="submit" name="action">Ver
					<i className="material-icons right">send</i>
				</a>
			</div>
		</div>
		<div className="divider light-blue darken-4 mb-divider"></div>
		<div className="row">
			<div className="col s6 m6 l6 x6">
				<h6>Resolución 741/10</h6>
			</div>
			<div className="col s6 m6 l6 x6 pull-x7">
				<a href="http://servicios.infoleg.gob.ar/infolegInternet/anexos/165000-169999/167725/norma.htm" target="_blank" className="btn waves-effect waves-light bg-latitud pulse" type="submit" name="action">Ver
					<i className="material-icons right">send</i>
				</a>
			</div>
		</div>
		<div className="divider light-blue darken-4 mb-divider"></div>
		<div className="row">
			<div className="col s6 m6 l6 x6">
				<h6>Resolución 1601/07</h6>
			</div>
			<div className="col s6 m6 l6 x6 pull-x7">
				<a href="http://servicios.infoleg.gob.ar/infolegInternet/anexos/130000-134999/133527/texact.htm" target="_blank" className="btn waves-effect waves-light bg-latitud pulse" type="submit" name="action">Ver
					<i className="material-icons right">send</i>
				</a>
			</div>
		</div>
		<div className="divider light-blue darken-4 mb-divider"></div>
		<div className="row">
			<div className="col s6 m6 l6 x6">
				<h6>Decreto 1694/09</h6>
			</div>
			<div className="col s6 m6 l6 x6 pull-x7">
				<a href="http://servicios.infoleg.gob.ar/infolegInternet/anexos/155000-159999/159765/norma.htm" target="_blank" className="btn waves-effect waves-light bg-latitud pulse" type="submit" name="action">Ver
					<i className="material-icons right">send</i>
				</a>
			</div>
		</div>
		<div className="divider light-blue darken-4 mb-divider"></div>
		<div className="row">
			<div className="col s6 m6 l6 x6">
				<h6>Resolución 363/16</h6>
			</div>
			<div className="col s6 m6 l6 x6 pull-x7">
				<a href="http://servicios.infoleg.gob.ar/infolegInternet/anexos/265000-269999/265441/norma.htm" target="_blank" className="btn waves-effect waves-light bg-latitud pulse" type="submit" name="action">Ver
					<i className="material-icons right">send</i>
				</a>
			</div>
		</div>
		<div className="divider light-blue darken-4 mb-divider"></div>
		<div className="row">
			<div className="col s6 m6 l6 x6">
				<h6>Resolución 463/09</h6>
			</div>
			<div className="col s6 m6 l6 x6 pull-x7">
				<a href="http://servicios.infoleg.gob.ar/infolegInternet/anexos/150000-154999/153431/texact.htm" target="_blank" className="btn waves-effect waves-light bg-latitud pulse" type="submit" name="action">Ver
					<i className="material-icons right">send</i>
				</a>
			</div>
		</div>
		<div className="divider light-blue darken-4 mb-divider"></div>
		<div className="row">
			<div className="col s6 m6 l6 x6">
				<h6>Resolución 529/09</h6>
			</div>
			<div className="col s6 m6 l6 x6 pull-x7">
				<a href="http://servicios.infoleg.gob.ar/infolegInternet/anexos/150000-154999/153837/norma.htm" target="_blank" className="btn waves-effect waves-light bg-latitud pulse" type="submit" name="action">Ver
					<i className="material-icons right">send</i>
				</a>
			</div>
		</div>
		<div className="divider light-blue darken-4 mb-divider"></div>
		<div className="row">
			<div className="col s6 m6 l6 x6">
				<h6>Ley 19587</h6>
			</div>
			<div className="col s6 m6 l6 x6 pull-x7">
				<a href="http://servicios.infoleg.gob.ar/infolegInternet/anexos/15000-19999/17612/norma.htm" target="_blank" className="btn waves-effect waves-light bg-latitud pulse" type="submit" name="action">Ver
					<i className="material-icons right">send</i>
				</a>
			</div>
		</div>
		<div className="divider light-blue darken-4 mb-divider"></div>
		<div className="row">
			<div className="col s6 m6 l6 x6">
				<h6>Decreto 170/96</h6>
			</div>
			<div className="col s6 m6 l6 x6 pull-x7">
				<a href="http://servicios.infoleg.gob.ar/infolegInternet/anexos/30000-34999/33757/texact.htm" target="_blank" className="btn waves-effect waves-light bg-latitud pulse" type="submit" name="action">Ver
					<i className="material-icons right">send</i>
				</a>
			</div>
		</div>
		<div className="divider light-blue darken-4 mb-divider"></div>
		<div className="row">
			<div className="col s6 m6 l6 x6">
				<h6>Decreto 911/96</h6>
			</div>
			<div className="col s6 m6 l6 x6 pull-x7">
				<a href="http://servicios.infoleg.gob.ar/infolegInternet/anexos/30000-34999/33757/texact.htm" target="_blank" className="btn waves-effect waves-light bg-latitud pulse" type="submit" name="action">Ver
					<i className="material-icons right">send</i>
				</a>
			</div>
		</div>
		<div className="divider light-blue darken-4 mb-divider"></div>
		<div className="row">
			<div className="col s6 m6 l6 x6">
				<h6>Resolución 861/15</h6>
			</div>
			<div className="col s6 m6 l6 x6 pull-x7">
				<a href="http://servicios.infoleg.gob.ar/infolegInternet/anexos/245000-249999/24621/7/norma.htm" target="_blank" className="btn waves-effect waves-light bg-latitud pulse" type="submit" name="action">Ver
					<i className="material-icons right">send</i>
				</a>
			</div>
		</div>
		<div className="divider light-blue darken-4 mb-divider"></div>
		<div className="row">
			<div className="col s6 m6 l6 x6">
				<h6>Resolución 84/12</h6>
			</div>
			<div className="col s6 m6 l6 x6 pull-x7">
				<a href="http://servicios.infoleg.gob.ar/infolegInternet/anexos/190000-194999/193616/norma.htm" target="_blank" className="btn waves-effect waves-light bg-latitud pulse" type="submit" name="action">Ver
					<i className="material-icons right">send</i>
				</a>
			</div>
		</div>
		<div className="divider light-blue darken-4 mb-divider"></div>
		<div className="row">
			<div className="col s6 m6 l6 x6">
				<h6>Resolución 886/15</h6>
			</div>
			<div className="col s6 m6 l6 x6 pull-x7">
				<a href="http://servicios.infoleg.gob.ar/infolegInternet/anexos/245000-249999/246272/norma.htm" target="_blank" className="btn waves-effect waves-light bg-latitud pulse" type="submit" name="action">Ver
					<i className="material-icons right">send</i>
				</a>
			</div>
		</div>
		<div className="divider light-blue darken-4 mb-divider"></div>
		<div className="row">
			<div className="col s6 m6 l6 x6">
				<h6>Resolución 801/15</h6>
			</div>
			<div className="col s6 m6 l6 x6 pull-x7">
				<a href="http://servicios.infoleg.gob.ar/infolegInternet/anexos/245000-249999/245850/norma.htm" target="_blank" className="btn waves-effect waves-light bg-latitud pulse" type="submit" name="action">Ver
					<i className="material-icons right">send</i>
				</a>
			</div>
		</div>
		<div className="divider light-blue darken-4 mb-divider"></div>
		<div className="row">
			<div className="col s6 m6 l6 x6">
				<h6>Resolución 85/12</h6>
			</div>
			<div className="col s6 m6 l6 x6 pull-x7">
				<a href="http://servicios.infoleg.gob.ar/infolegInternet/anexos/190000-194999/193617/norma.htm" target="_blank" className="btn waves-effect waves-light bg-latitud pulse" type="submit" name="action">Ver
					<i className="material-icons right">send</i>
				</a>
			</div>
		</div>
		<div className="divider light-blue darken-4 mb-divider"></div>
		<div className="row">
			<div className="col s6 m6 l6 x6">
				<h6>Resolución 503/14</h6>
			</div>
			<div className="col s6 m6 l6 x6 pull-x7">
				<a href="http://servicios.infoleg.gob.ar/infolegInternet/anexos/225000-229999/227747/norma.htm" target="_blank" className="btn waves-effect waves-light bg-latitud pulse" type="submit" name="action">Ver
					<i className="material-icons right">send</i>
				</a>
			</div>
		</div>
		<div className="divider light-blue darken-4 mb-divider"></div>
		<div className="row">
			<div className="col s6 m6 l6 x6">
				<h6>Resolución 299/11</h6>
			</div>
			<div className="col s6 m6 l6 x6 pull-x7">
				<a href="http://servicios.infoleg.gob.ar/infolegInternet/anexos/180000-184999/180669/norma.htm" target="_blank" className="btn waves-effect waves-light bg-latitud pulse" type="submit" name="action">Ver
					<i className="material-icons right">send</i>
				</a>
			</div>
		</div>
		<div className="divider light-blue darken-4 mb-divider"></div>
		<div className="row">
			<div className="col s6 m6 l6 x6">
				<h6>Resolución 550/11</h6>
			</div>
			<div className="col s6 m6 l6 x6 pull-x7">
				<a href="http://servicios.infoleg.gob.ar/infolegInternet/anexos/180000-184999/181606/norma.htm" target="_blank" className="btn waves-effect waves-light bg-latitud pulse" type="submit" name="action">Ver
					<i className="material-icons right">send</i>
				</a>
			</div>
		</div>
		<div className="divider light-blue darken-4 mb-divider"></div>
		<div className="row">
			<div className="col s6 m6 l6 x6">
				<h6>Resolución 37/10</h6>
			</div>
			<div className="col s6 m6 l6 x6 pull-x7">
				<a href="http://servicios.infoleg.gob.ar/infolegInternet/anexos/160000-164999/163171/norma.htm" target="_blank" className="btn waves-effect waves-light bg-latitud pulse" type="submit" name="action">Ver
					<i className="material-icons right">send</i>
				</a>
			</div>
		</div>
		<div className="divider light-blue darken-4 mb-divider"></div>
		<div className="row">
			<div className="col s6 m6 l6 x6">
				<h6>Resolución 497/03</h6>
			</div>
			<div className="col s6 m6 l6 x6 pull-x7">
				<a href="http://servicios.infoleg.gob.ar/infolegInternet/anexos/85000-89999/89125/texact.htm" target="_blank" className="btn waves-effect waves-light bg-latitud pulse" type="submit" name="action">Ver
					<i className="material-icons right">send</i>
				</a>
			</div>
		</div>
		<div className="divider light-blue darken-4 mb-divider"></div>
		<div className="row">
			<div className="col s6 m6 l6 x6">
				<h6>Resolución 20/18</h6>
			</div>
			<div className="col s6 m6 l6 x6 pull-x7">
				<a href="http://servicios.infoleg.gob.ar/infolegInternet/anexos/305000-309999/307746/norma.htm" target="_blank" className="btn waves-effect waves-light bg-latitud pulse" type="submit" name="action">Ver
					<i className="material-icons right">send</i>
				</a>
			</div>
		</div>
		<div className="divider light-blue darken-4 mb-divider"></div>
		<div className="row">
			<div className="col s6 m6 l6 x6">
				<h6>Resolución 51/97</h6>
			</div>
			<div className="col s6 m6 l6 x6 pull-x7">
				<a href="http://servicios.infoleg.gob.ar/infolegInternet/anexos/40000-44999/44588/norma.htm" target="_blank" className="btn waves-effect waves-light bg-latitud pulse" type="submit" name="action">Ver
					<i className="material-icons right">send</i>
				</a>
			</div>
		</div>
		<div className="divider light-blue darken-4 mb-divider"></div>
		<div className="row">
			<div className="col s6 m6 l6 x6">
				<h6>Resolución 35/98</h6>
			</div>
			<div className="col s6 m6 l6 x6 pull-x7">
				<a href="http://servicios.infoleg.gob.ar/infolegInternet/anexos/50000-54999/50188/norma.htm" target="_blanka" className="btn waves-effect waves-light bg-latitud pulse" type="submit" name="action">Ver
					<i className="material-icons right">send</i>
				</a>
			</div>
		</div>
		<div className="divider light-blue darken-4 mb-divider"></div>
		<div className="row">
			<div className="col s6 m6 l6 x6">
				<h6>Resolución 319/99</h6>
			</div>
			<div className="col s6 m6 l6 x6 pull-x7">
				<a href="http://servicios.infoleg.gob.ar/infolegInternet/anexos/55000-59999/59941/norma.htm" target="_blank" className="btn waves-effect waves-light bg-latitud pulse" type="submit" name="action">Ver
					<i className="material-icons right">send</i>
				</a>
			</div>
		</div>
		<div className="divider light-blue darken-4 mb-divider"></div>
		<div className="row">
			<div className="col s6 m6 l6 x6">
				<h6>Resolución 844/17</h6>
			</div>
			<div className="col s6 m6 l6 x6 pull-x7">
				<a href="http://servicios.infoleg.gob.ar/infolegInternet/anexos/275000-279999/278079/norma.htm" target="_blank" className="btn waves-effect waves-light bg-latitud pulse" type="submit" name="action">Ver
					<i className="material-icons right">send</i>
				</a>
			</div>
		</div>
		<div className="divider light-blue darken-4 mb-divider"></div>
		<div className="row">
			<div className="col s6 m6 l6 x6">
				<h6>Resolución 743/03</h6>
			</div>
			<div className="col s6 m6 l6 x6 pull-x7">
				<a href="http://servicios.infoleg.gob.ar/infolegInternet/anexos/90000-94999/90519/norma.htm" target="_blank" className="btn waves-effect waves-light bg-latitud pulse" type="submit" name="action">Ver
					<i className="material-icons right">send</i>
				</a>
			</div>
		</div>
		<div className="divider light-blue darken-4 mb-divider"></div>
		<div className="row">
			<div className="col s6 m6 l6 x6">
				<h6>Resolución 960/15</h6>
			</div>
			<div className="col s6 m6 l6 x6 pull-x7">
				<a href="http://servicios.infoleg.gob.ar/infolegInternet/anexos/245000-249999/246619/norma.htm" target="_blank" className="btn waves-effect waves-light bg-latitud pulse" type="submit" name="action">Ver
					<i className="material-icons right">send</i>
				</a>
			</div>
		</div>
		<div className="divider light-blue darken-4 mb-divider"></div>
		<div className="row">
			<div className="col s6 m6 l6 x6">
				<h6>Resolución 905/15</h6>
			</div>
			<div className="col s6 m6 l6 x6 pull-x7">
				<a href="http://servicios.infoleg.gob.ar/infolegInternet/anexos/245000-249999/246509/norma.htm" target="_blank" className="btn waves-effect waves-light bg-latitud pulse" type="submit" name="action">Ver
					<i className="material-icons right">send</i>
				</a>
			</div>
		</div>
		<div className="divider light-blue darken-4 mb-divider"></div>
		<div className="row">
			<div className="col s6 m6 l6 x6">
				<h6>Resolución 900/15</h6>
			</div>
			<div className="col s6 m6 l6 x6 pull-x7">
				<a href="http://servicios.infoleg.gob.ar/infolegInternet/anexos/245000-249999/246348/norma.htm" target="_blank" className="btn waves-effect waves-light bg-latitud pulse" type="submit" name="action">Ver
					<i className="material-icons right">send</i>
				</a>
			</div>
		</div>
		<div className="divider light-blue darken-4 mb-divider"></div>
		<div className="row">
			<div className="col s6 m6 l6 x6">
				<h6>Resolución 887/15</h6>
			</div>
			<div className="col s6 m6 l6 x6 pull-x7">
				<a href="http://servicios.infoleg.gob.ar/infolegInternet/anexos/245000-249999/246306/norma.htm" target="_blank" className="btn waves-effect waves-light bg-latitud pulse" type="submit" name="action">Ver
					<i className="material-icons right">send</i>
				</a>
			</div>
		</div>
		<div className="divider light-blue darken-4 mb-divider"></div>
		<div className="row">
			<div className="col s6 m6 l6 x6">
				<h6>Resolución 886/15</h6>
			</div>
			<div className="col s6 m6 l6 x6 pull-x7">
				<a href="http://servicios.infoleg.gob.ar/infolegInternet/anexos/245000-249999/246272/norma.htm" target="_blank" className="btn waves-effect waves-light bg-latitud pulse" type="submit" name="action">Ver
					<i className="material-icons right">send</i>
				</a>
			</div>
		</div>
		<div className="divider light-blue darken-4 mb-divider"></div>
		<div className="row">
			<div className="col s6 m6 l6 x6">
				<h6>Resolución 861/15</h6>
			</div>
			<div className="col s6 m6 l6 x6 pull-x7">
				<a href="http://servicios.infoleg.gob.ar/infolegInternet/anexos/245000-249999/246217/norma.htm" target="_blank" className="btn waves-effect waves-light bg-latitud pulse" type="submit" name="action">Ver
					<i className="material-icons right">send</i>
				</a>
			</div>
		</div>
		<div className="divider light-blue darken-4 mb-divider"></div>
		<div className="row">
			<div className="col s6 m6 l6 x6">
				<h6>Resolución 617/97</h6>
			</div>
			<div className="col s6 m6 l6 x6 pull-x7">
				<a href="http://servicios.infoleg.gob.ar/infolegInternet/anexos/75000-79999/79053/texact.htm" target="_blank" className="btn waves-effect waves-light bg-latitud pulse" type="submit" name="action">Ver
					<i className="material-icons right">send</i>
				</a>
			</div>
		</div>
		<div className="divider light-blue darken-4 mb-divider"></div>
		<div className="row">
			<div className="col s6 m6 l6 x6">
				<h6>Resolución 475/11</h6>
			</div>
			<div className="col s6 m6 l6 x6 pull-x7">
				<a href="http://servicios.infoleg.gob.ar/infolegInternet/anexos/180000-184999/181146/norma.htm" target="_blank" className="btn waves-effect waves-light bg-latitud pulse" type="submit" name="action">Ver
					<i className="material-icons right">send</i>
				</a>
			</div>
		</div>
		<div className="divider light-blue darken-4 mb-divider"></div>
		<div className="row">
			<div className="col s6 m6 l6 x6">
				<h6>Resolución 771/13</h6>
			</div>
			<div className="col s6 m6 l6 x6 pull-x7">
				<a href="http://servicios.infoleg.gob.ar/infolegInternet/anexos/180000-184999/181146/norma.htm" target="_blank" className="btn waves-effect waves-light bg-latitud pulse" type="submit" name="action">Ver
					<i className="material-icons right">send</i>
				</a>
			</div>
		</div>
		<div className="divider light-blue darken-4 mb-divider"></div>
		<div className="row">
			<div className="col s6 m6 l6 x6">
				<h6>Resolución 559/09</h6>
			</div>
			<div className="col s6 m6 l6 x6 pull-x7">
				<a href="http://servicios.infoleg.gob.ar/infolegInternet/anexos/150000-154999/153998/norma.htm" target="_blank" className="btn waves-effect waves-light bg-latitud pulse" type="submit" name="action">Ver
					<i className="material-icons right">send</i>
				</a>
			</div>
		</div>
		<div className="divider light-blue darken-4 mb-divider"></div>
		<div className="row">
			<div className="col s6 m6 l6 x6">
				<h6>Resolución 415/02</h6>
			</div>
			<div className="col s6 m6 l6 x6 pull-x7">
				<a href="http://servicios.infoleg.gob.ar/infolegInternet/anexos/75000-79999/79053/texact.htm" target="_blank" className="btn waves-effect waves-light bg-latitud pulse" type="submit" name="action">Ver
					<i className="material-icons right">send</i>
				</a>
			</div>
		</div>
		<div className="divider light-blue darken-4 mb-divider"></div>
		<div className="row">
			<div className="col s6 m6 l6 x6">
				<h6>Resolución 1721/04</h6>
			</div>
			<div className="col s6 m6 l6 x6 pull-x7">
				<a href="http://servicios.infoleg.gob.ar/infolegInternet/anexos/100000-104999/102201/norma.htm" target="_blank" className="btn waves-effect waves-light bg-latitud pulse" type="submit" name="action">Ver
					<i className="material-icons right">send</i>
				</a>
			</div>
		</div>
		<div className="divider light-blue darken-4 mb-divider"></div>
		<div className="row">
			<div className="col s6 m6 l6 x6">
				<h6>Resolución 351/79</h6>
			</div>
			<div className="col s6 m6 l6 x6 pull-x7">
				<a href="http://servicios.infoleg.gob.ar/infolegInternet/anexos/30000-34999/32030/texact.htm" target="_blank" className="btn waves-effect waves-light bg-latitud pulse" type="submit" name="action">Ver
					<i className="material-icons right">send</i>
				</a>
			</div>
		</div>
		<div className="divider light-blue darken-4 mb-divider"></div>
		<div className="row">
			<div className="col s6 m6 l6 x6">
				<h6>Resolución 1735/09</h6>
			</div>
			<div className="col s6 m6 l6 x6 pull-x7">
				<a href="http://servicios.infoleg.gob.ar/infolegInternet/anexos/160000-164999/162449/norma.htm" target="_blank" className="btn waves-effect waves-light bg-latitud pulse" type="submit" name="action">Ver
					<i className="material-icons right">send</i>
				</a>
			</div>
		</div>
		<div className="divider light-blue darken-4 mb-divider"></div>
		<div className="row">
			<div className="col s6 m6 l6 x6">
				<h6>Resolución 365/09</h6>
			</div>
			<div className="col s6 m6 l6 x6 pull-x7">
				<a href="http://servicios.infoleg.gob.ar/infolegInternet/anexos/150000-154999/152416/norma.htm" target="_blank" className="btn waves-effect waves-light bg-latitud pulse" type="submit" name="action">Ver
					<i className="material-icons right">send</i>
				</a>
			</div>
		</div>
		<div className="divider light-blue darken-4 mb-divider"></div>
		<div className="row">
			<div className="col s6 m6 l6 x6">
				<h6>Resolución 230/03</h6>
			</div>
			<div className="col s6 m6 l6 x6 pull-x7">
				<a href="http://servicios.infoleg.gob.ar/infolegInternet/anexos/85000-89999/85244/norma.htm" target="_blank" className="btn waves-effect waves-light bg-latitud pulse" type="submit" name="action">Ver
					<i className="material-icons right">send</i>
				</a>
			</div>
		</div>
		<div className="divider light-blue darken-4 mb-divider"></div>
		<div className="row">
			<div className="col s6 m6 l6 x6">
				<h6>Resolución 310/02</h6>
			</div>
			<div className="col s6 m6 l6 x6 pull-x7">
				<a href="http://servicios.infoleg.gob.ar/infolegInternet/anexos/80000-84999/80556/norma.htm" target="_blank" className="btn waves-effect waves-light bg-latitud pulse" type="submit" name="action">Ver
					<i className="material-icons right">send</i>
				</a>
			</div>
		</div>
		<div className="divider light-blue darken-4 mb-divider"></div>
      </>
   )
}

export default Srt